import { makeStyles } from "@material-ui/core/styles";
import { service, theme } from "src/styles/themes";

const useStyles = makeStyles(() => ({
  wrapper: {
    borderRadius: 12,
    boxShadow: "0 8px 24px 0 rgba(33, 37, 41, 0.10)",
    border: `solid 1px ${service.gray_200}`,
    backgroundColor: service.white,
    overflow: "hidden",
    padding: "6px 0",
  },
  option: {
    width: "100%",
    padding: "10px 16px",
    cursor: "pointer",
    transition: "background-color .15s",
    "&:hover": {
      backgroundColor: service.gray_50,
      "& p": {
        color: `${service.primary_700} !important`,
        ...theme.font_bold,
      },
    },
  },
}));

export default useStyles;
